import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedRole: "Supplier Admin",
}

export const setRoleStore = createSlice({
  name: 'setRole',
  initialState,
  reducers: {
    setHeaderRole: (state, action) => {
      state.selectedRole = action.payload
    }
  },
})

export const { setHeaderRole } = setRoleStore.actions;

export default setRoleStore.reducer;